import VueNumber from 'vue-number-animation'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('NumberAnimation', VueNumber)
  nuxtApp.vueApp.component('VueNumberAnimation', VueNumber)
})
